export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_LOGIN_RESET = 'USER_LOGIN_RESET'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'
export const USER_REGISTER_RESET = 'USER_REGISTER_RESET'

export const USER_CONFIRM_REGISTER_REQUEST = 'USER_CONFIRM_REGISTER_REQUEST'
export const USER_CONFIRM_REGISTER_SUCCESS = 'USER_CONFIRM_REGISTER_SUCCESS'
export const USER_CONFIRM_REGISTER_FAIL = 'USER_CONFIRM_REGISTER_FAIL'

export const USER_LIST_OF_PAID_INVOICES_REQUEST = 'USER_LIST_OF_PAID_INVOICES_REQUEST'
export const USER_LIST_OF_PAID_INVOICES_REQUEST_SUCCESS = 'USER_LIST_OF_PAID_INVOICES_REQUEST_SUCCESS'
export const USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL = 'USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL'

export const USER_LIST_OF_UNPAID_INVOICES_REQUEST = 'USER_LIST_OF_UNPAID_INVOICES_REQUEST'
export const USER_LIST_OF_UNPAID_INVOICES_REQUEST_SUCCESS = 'USER_LIST_OF_UNPAID_INVOICES_REQUEST_SUCCESS'
export const USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL = 'USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL'

export const USER_PROFILE_INFORMATION_REQUEST = 'USER_PROFILE_INFORMATION_REQUEST'
export const USER_PROFILE_INFORMATION_REQUEST_SUCCESS = 'USER_PROFILE_INFORMATION_REQUEST_SUCCESS'
export const USER_PROFILE_INFORMATION_REQUEST_FAIL = 'USER_PROFILE_INFORMATION_REQUEST_FAIL'

export const USER_UPDATE_PROFILE_REQUEST = 'USER_UPDATE_PROFILE_REQUEST'
export const USER_UPDATE_PROFILE_REQUEST_SUCCESS = 'USER_UPDATE_PROFILE_SUCCESS'
export const USER_UPDATE_PROFILE_REQUEST_FAIL = 'USER_UPDATE_PROFILE_FAIL'
export const USER_UPDATE_PROFILE_RESET = 'USER_UPDATE_PROFILE_RESET'

export const USER_ADD_BOOKMARCK_REQUEST = 'USER_ADD_BOOKMARCK_REQUEST'
export const USER_ADD_BOOKMARCK_REQUEST_SUCCESS = 'USER_ADD_BOOKMARCK_REQUEST_SUCCESS'
export const USER_ADD_BOOKMARCK_REQUEST_FAIL = 'USER_ADD_BOOKMARCK_REQUEST_FAIL'

export const USER_REMOVE_BOOKMARCK_REQUEST = 'USER_REMOVE_BOOKMARCK_REQUEST'
export const USER_REMOVE_BOOKMARCK_REQUEST_SUCCESS = 'USER_REMOVE_BOOKMARCK_REQUEST_SUCCESS'
export const USER_REMOVE_BOOKMARCK_REQUEST_FAIL = 'USER_REMOVE_BOOKMARCK_REQUEST_FAIL'

export const USER_UPDATE_PASSWORD_REQUEST = 'USER_UPDATE_PASSWORD_REQUEST'
export const USER_UPDATE_PASSWORD_REQUEST_SUCCESS = 'USER_UPDATE_PASSWORD_REQUEST_SUCCESS'
export const USER_UPDATE_PASSWORD_REQUEST_FAIL = 'USER_UPDATE_PASSWORD_REQUEST_FAIL'

export const USER_UPDATE_IMAGE_REQUEST = 'USER_UPDATE_IMAGE_REQUEST'
export const USER_UPDATE_IMAGE_SUCCESS = 'USER_UPDATE_IMAGE_SUCCESS'
export const USER_UPDATE_IMAGE_FAIL = 'USER_UPDATE_IMAGE_FAIL'

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST'
export const USER_RESET_PASSWORD_REQUEST_SUCCESS = 'USER_RESET_PASSWORD_REQUEST_SUCCESS'
export const USER_RESET_PASSWORD_REQUEST_FAIL = 'USER_RESET_PASSWORD_REQUEST_FAIL'
export const USER_RESET_PASSWORD_REQUEST_RESET = 'USER_RESET_PASSWORD_REQUEST_RESET'

export const USER_CREATE_PASSWORD_REQUEST = 'USER_CREATE_PASSWORD_REQUEST'
export const USER_CREATE_PASSWORD_SUCCESS = 'USER_CREATE_PASSWORD_SUCCESS'
export const USER_CREATE_PASSWORD_FAIL = 'USER_CREATE_PASSWORD_FAIL'

export const USER_RECOVERY_REQUEST = 'USER_RECOVERY_REQUEST'
export const USER_RECOVERY_SUCCESS = 'USER_RECOVERY_SUCCESS'
export const USER_RECOVERY_FAIL = 'USER_RECOVERY_FAIL'
export const USER_RECOVERY_RESET = 'USER_RECOVERY_RESET'

export const USER_DETAILS_RESET = 'USER_DETAILS_RESET'
export const USER_LIST_RESET = 'USER_LIST_RESET'
